module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedBlack.bf4d179.woff2";